var position = $(window).scrollTop() ;
$('document').ready(function () {
    stylizeBody();
    initCarrousels();
  $("#register-user").validate();
  $("#ContactForm").validate();
   populateCountries("country", "state"); // first parameter is id of country drop-down and second parameter is id of state drop-down
  if($('#country-contact').length > 0){
   populateCountries("country-contact", "state-contact");
  }
})
	


$(window).resize(function () {
    stylizeBody()
});
// should start at 0
$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var scrollHeight = $(document).height();
	var scrollPosition = $(window).height() + $(window).scrollTop();
	
    if (scroll <=0) {
        $('header').removeClass('fixed-header scroll');
       $('.announcement-bar').removeClass('d-none');
    }else{
      if (scroll > position && ((scrollHeight - scrollPosition) / scrollHeight > 1)) {
          $('header').addClass('fixed-header scroll');
        
          //$('.menu-mobile .menu-dropdown .sub-menu').slideUp('10');
          $('.announcement-bar').addClass('d-none');
      } else {
       
          	$('header').removeClass(' scroll');
          
      }
    }
    
    position = scroll;
    stylizeBody();
});

function stylizeBody() {
    var headerHeight = $('header').outerHeight();
    var anunc = $('.announcement-bar').outerHeight();
    var heightH = headerHeight + anunc;
    $('main').css('padding-top', heightH);
}

function initCarrousels() {
    $('.brands-carrousel').slick({
        infinite: true,
        speed: 300,
        slidesToShow: 6,
        slidesToScroll: 1,
        prevArrow: '<button id="brand-prev" class="btn-arrow btn-prev"><i class="icon icon-arrow-left"></i></button>',
        nextArrow: '<button id="brand-next" class="btn-arrow btn-next"><i class="icon icon-arrow-right"></i></button>',
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2
                }
            }
          ]
    });
    $('#related-carousel').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        prevArrow: '<button id="featured-prev" class="btn-arrow btn-prev"><i class="icon icon-arrow-left"></i></button>',
        nextArrow: '<button id="featured-next" class="btn-arrow btn-next"><i class="icon icon-arrow-right"></i></button>',
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 4,
                  slidesToScroll: 4
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                  slidesToScroll: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                  slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                  slidesToScroll: 1
                }
            }
          ]
    });
    
    $('.product-images-thumbs').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<button id="thumbs-prev" class="btn-arrow btn-prev"><i class="icon icon-arrow-up"></i></button>',
        nextArrow: '<button id="thumbs-next" class="btn-arrow btn-next"><i class="icon icon-arrow-down"></i></button>',
        asNavFor: '.product-images-carrousel',
        dots: false,
        vertical: true,
        focusOnSelect: true
    });
    $('.product-images-carrousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.product-images-thumbs',
        responsive: [
        {
          breakpoint: 600,
          settings: {
            dots: true
          }
        }
        ]
          
    });
    $('#featured-carousel').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: '<button id="featured-prev" class="btn-arrow btn-prev"><i class="icon icon-arrow-left"></i></button>',
        nextArrow: '<button id="featured-next" class="btn-arrow btn-next"><i class="icon icon-arrow-right"></i></button>',
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
          ]
    });
}
$('.btn-burguer-menu').on('click', function () {
    $('.mobile-header nav.navbar-section').toggle(200, function () {
        if ($(this).css('display') == 'block') {
            $('.btn-burguer-menu').addClass('active');
        } else {
            $('.btn-burguer-menu').removeClass('active');
        }
    });
});

$('.menu-dropdown > .btn-link').on('click', function () {
    var menuDrop = $(this).parent();
    var subMenu = $(".sub-menu");
    $('.menu-dropdown').not(menuDrop).removeClass('active');
    $(".sub-menu").not(menuDrop.find(subMenu)).css('display','none');

    if (menuDrop.hasClass('active')) {
        menuDrop.removeClass('active');
        menuDrop.find(subMenu).slideUp('10');
    } else {
        menuDrop.addClass('active');
        menuDrop.find(subMenu).slideDown('10');
    };
});
$( ".sub-menu" ).mouseleave(function() {
	$('.menu-dropdown').removeClass('active');
    $('.sub-menu').slideUp('10');
});
$('.btn-grid').on('click', function () {
    $('.grid-control-btn').removeClass('active-grid');
    $(this).addClass('active-grid');
    $('.product-item').parent().removeClass('col-12');
    $('.product-item').removeClass('product-list');
    $('.product-item').parent().addClass('col-sm-6 col-lg-4 col-3');
    $('.product-item').addClass('product-grid');
});
$('.btn-list').on('click', function () {
    $('.grid-control-btn').removeClass('active-grid');
    $(this).addClass('active-grid');
    $('.product-item').parent().removeClass('col-sm-6 col-lg-4 col-3');
    $('.product-item').removeClass('product-grid');
    $('.product-item').parent().addClass('col-12');
    $('.product-item').addClass('product-list');
});

$(".open-sign").on("click", function () {
    $('#login-modal').addClass('active');
}), $("#login-modal .create-account-btn").on("click", function () {
    $("#loginAccount").fadeOut(100), $("#createAccount").delay(200).fadeIn(200)
}), $(".login-account-link").on("click", function () {
    $("#createAccount").fadeOut(100), $("#loginAccount").delay(200).fadeIn(200)
}), $("#btn-recover-pass").on("click", function () {
    $("#loginAccount").fadeOut(100), $("#recover-pass").delay(200).fadeIn(200)
}), $("#HideRecoverPasswordLink").on("click", function () {
    $("#recover-pass").fadeOut(100), $("#loginAccount").delay(200).fadeIn(200)
});
$('.product-qty').each(function () {
    var spinner = jQuery(this),
        input = spinner.find('input[type="number"]'),
        btnUp = spinner.find('.quantity-up'),
        btnDown = spinner.find('.quantity-down'),
        min = input.attr('min'),
        max = input.attr('max');

    btnUp.click(function () {
        var oldValue = parseFloat(input.val());
        if (oldValue >= max) {
            var newVal = oldValue;
        } else {
            var newVal = oldValue + 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
    });

    btnDown.click(function () {
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
            var newVal = oldValue;
        } else {
            var newVal = oldValue - 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
    });

});

 $( ".product-qty" ).change(function() {
      var min = parseInt($(this).attr('min'));
      var max = parseInt($(this).attr('max'));
       if ($(this).val() > max)
       {
          $(this).val(max);
       }
       else if ($(this).val() < min)
       {
          $(this).val(min);
       }           
    }); 
$('.modal-overlay').on('click',function(){
	$('.modal').removeClass('active');
});
$('.btn-clear').on('click',function(){
	$('.modal').removeClass('active');
});
/*$('.close-msg').on('click',function(){
	$('.extra-msg').addClass('d-none');
});*/


/*function validateForm(form){
	var inputs = $(form).filter(":input");
    var msg = $('.form-input-hint');
    inputs.each(function() {
      if($(this).val() == "" && $(this).hasClass('required')){
        $(this).addClass('is-error');
        $(this).parent().find(msg).style('display','block');
      }
    });
};*/